import router from './router'
import store from '@/store'
import { Toast } from 'vant'
import { i18n, vantLocales } from '@/lang'
vantLocales(i18n.locale)

router.beforeEach(async (to, from, next) => {
  // 自主导航
  console.log(to.path, 'to.path')
  if (to.path === '/twfthJourney') {
    const parameters = {
      method: 'setAppNavBar',
      navBarColor: '#33513A',
      navItemColor: '#FFFFFF'
    }
    const userAgent = navigator.userAgent
    if (/iPad|iPhone|iPod/i.test(userAgent)) {
      window.webkit.messageHandlers.msgToNative.postMessage(parameters)
    } else if (/android/i.test(userAgent)) {
      window.android.setAppNavBar(JSON.stringify(parameters))
    }
    //   自主导航结束
    window.getAppHeaders = (obj) => {
      const userAgent = navigator.userAgent
      if (/iPad|iPhone|iPod/i.test(userAgent)) {
      // 如果是ios
        store.commit('appLang/setAppObj', obj)
        next()
      } else if (/android/i.test(userAgent)) {
      // 如果是安卓
        const objNew = JSON.parse(obj)
        store.commit('appLang/setAppObj', objNew)
        next()
      }
    }
    function getAppHeaderser (callback) {
      try {
        const info = {
          method: 'getAppHeaders'
        }
        const userAgent = navigator.userAgent
        if (/iPad|iPhone|iPod/i.test(userAgent)) {
          window.webkit.messageHandlers.msgToNative.postMessage(info)
        } else if (/android/i.test(userAgent)) {
          const userHeaders = window.android.getAppHeaders()
          console.log(userHeaders, 'userHeaders安卓值')
          callback(userHeaders)
        }
      } catch (e) {
        Toast(
          {
            type: 'html',
            message: '<div style="width: 5.386666rem; white-space: pre-wrap;word-break: break-word">Please update the app to the latest version</div>'
          }
        )
      }
    }
    try {
      getAppHeaderser((data) => {
        window.getAppHeaders(data)
      })
    } catch (e) {
      Toast(
        {
          type: 'html',
          message: '<div style="width: 5.386666rem; white-space: pre-wrap;word-break: break-word">Please update the app to the latest version</div>'
        }
      )
    }
  } else {
    next()
  }
})
